import { ObjectCompare } from "src/utils";
import {
  AmendTransitPurchaseOrderFormData,
  PatchTransitPurchaseOrderRequestBody,
  TransitProduct,
  TransitProductAmendmentInputField,
  TransitPurchaseOrder
} from "src/types";
import { IdGenerator } from "src/utils";

export class AmendTransitPurchaseOrderMapper {
  public static initAmendTransitPurchaseOrderFormData(): AmendTransitPurchaseOrderFormData {
    return {
      purchaseOrderId: "",
      productAmendments: []
    };
  }

  public static transitProductAmendmentInputFieldFromProducts(
    products: TransitProduct[]
  ): TransitProductAmendmentInputField[] {
    return products.map((product) => ({
      id: product.id,
      name: product.name,
      skuName: product.skuName,
      barcode: product.barcode,
      size: product.size,
      ukQuantity: product.ukQuantity,
      euQuantity: product.euQuantity,
      orderedQuantity: product.orderedQuantity, // Ordered quantity
      confirmedQuantity: product.confirmedQuantity, // Confirmed quantity
      warehouseLogQuantity: product.warehouseLogQuantity, // Warehouse log quantity
      childWarehouseLogQuantity: product.childWarehouseLogQuantity, // Child warehouse log quantity
      fieldId: IdGenerator.generateUniqueElementId(product.id),
      amendedReceivedQty: (product.receivedQuantity ?? 0).toString(),
      orderReceivedQty: (product.receivedQuantity ?? 0).toString()
    }));
  }

  public static initAmendTransitPurchaseOrderFormDataFromTransitPurchaseOrder(
    transitPurchaseOrder: TransitPurchaseOrder
  ): AmendTransitPurchaseOrderFormData {
    return {
      purchaseOrderId: transitPurchaseOrder.id,
      productAmendments: AmendTransitPurchaseOrderMapper.transitProductAmendmentInputFieldFromProducts(
        transitPurchaseOrder.products ?? []
      )
    };
  }

  public static amendTransitPurchaseOrderRequestBodyFromFormData(
    formData: AmendTransitPurchaseOrderFormData,
    initialFormData?: AmendTransitPurchaseOrderFormData
  ): PatchTransitPurchaseOrderRequestBody {
    const productAmendmentsNoChange = ObjectCompare.isEqual(
      initialFormData?.productAmendments,
      formData.productAmendments
    );

    const normalisedProductAmendments = productAmendmentsNoChange
      ? []
      : formData.productAmendments.map((amendment) => ({
          id: amendment.id,
          receivedQuantity: parseInt(amendment.amendedReceivedQty, 10) || 0
        }));

    return {
      products: normalisedProductAmendments
    };
  }
}
